import CommentsList from './commentsList';

export default CommentsList;
